import React from 'react'

import Box from '@mui/material/Box'

import SideBar from './SideBar/SideBar'
import { SideBarSelection } from '../../utils/Type'

interface RootLayoutProps {
  children: React.ReactNode
}

const RootLayout = ({ children }: RootLayoutProps) => {
  const sideBarSelections: SideBarSelection[] = [
    {
      name: 'Photos',
      icon: 'image',
      path: '/'
    },
    {
      name: 'Valentines',
      icon: 'favorite',
      path: '/valentines'
    }
  ]
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row' }}>
      <SideBar sideBarSelections={sideBarSelections} />
      <Box
        sx={{
          marginTop: { xs: 7.5, md: 0 },
          width: { xs: 1, md: 'calc(100vw - 240px)' }
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default RootLayout
